import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface ConfigurationIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  active: boolean;
}
function ConfigurationIcon(t0) {
  const $ = _c(22);
  const {
    active
  } = t0;
  const t1 = active ? "rgb(var(--brand-primary))" : "rgb(var(--fill-primary))";
  let t2;
  if ($[0] !== t1) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M14.1971 0H5.8129C2.17109 0 0 2.17 0 5.81V14.18C0 17.83 2.17108 20 5.8129 20H14.1871C17.8289 20 20 17.83 20 14.19V5.81C20.01 2.17 17.8389 0 14.1971 0Z" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t4;
  if ($[2] !== t3) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M13.5859 17.2501C13.1759 17.2501 12.8359 16.9101 12.8359 16.5001V12.6001C12.8359 12.1901 13.1759 11.8501 13.5859 11.8501C13.9959 11.8501 14.3359 12.1901 14.3359 12.6001V16.5001C14.3359 16.9101 13.9959 17.2501 13.5859 17.2501Z" fill={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t6;
  if ($[4] !== t5) {
    t6 = <path fillRule="evenodd" clipRule="evenodd" d="M13.5859 6.2C13.1759 6.2 12.8359 5.86 12.8359 5.45V3.5C12.8359 3.09 13.1759 2.75 13.5859 2.75C13.9959 2.75 14.3359 3.09 14.3359 3.5V5.45C14.3359 5.86 13.9959 6.2 13.5859 6.2Z" fill={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t8;
  if ($[6] !== t7) {
    t8 = <path fillRule="evenodd" clipRule="evenodd" d="M6.42188 17.25C6.01188 17.25 5.67188 16.91 5.67188 16.5V14.55C5.67188 14.14 6.01188 13.8 6.42188 13.8C6.83187 13.8 7.17188 14.14 7.17188 14.55V16.5C7.17188 16.91 6.84187 17.25 6.42188 17.25Z" fill={t7} />;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t10;
  if ($[8] !== t9) {
    t10 = <path fillRule="evenodd" clipRule="evenodd" d="M6.42188 8.15C6.01188 8.15 5.67188 7.81 5.67188 7.4V3.5C5.67188 3.09 6.01188 2.75 6.42188 2.75C6.83187 2.75 7.17188 3.09 7.17188 3.5V7.4C7.17188 7.81 6.84187 8.15 6.42188 8.15Z" fill={t9} />;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t12;
  if ($[10] !== t11) {
    t12 = <path fillRule="evenodd" clipRule="evenodd" d="M13.5855 5.33008C12.0855 5.33008 10.8555 6.55008 10.8555 8.05008C10.8555 9.55008 12.0755 10.7801 13.5855 10.7801C15.0855 10.7801 16.3055 9.56008 16.3055 8.05008C16.3055 6.54008 15.0855 5.33008 13.5855 5.33008Z" fill={t11} />;
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const t13 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t14;
  if ($[12] !== t13) {
    t14 = <path fillRule="evenodd" clipRule="evenodd" d="M6.42313 9.22998C4.92313 9.22998 3.70312 10.45 3.70312 11.96C3.70312 13.47 4.92313 14.68 6.42313 14.68C7.92313 14.68 9.15312 13.46 9.15312 11.96C9.15312 10.46 7.93313 9.22998 6.42313 9.22998Z" fill={t13} />;
    $[12] = t13;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t10 || $[15] !== t12 || $[16] !== t14 || $[17] !== t2 || $[18] !== t4 || $[19] !== t6 || $[20] !== t8) {
    t15 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t4}{t6}{t8}{t10}{t12}{t14}</svg>;
    $[14] = t10;
    $[15] = t12;
    $[16] = t14;
    $[17] = t2;
    $[18] = t4;
    $[19] = t6;
    $[20] = t8;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  return t15;
}
export default ConfigurationIcon;